/**
 * SNU 회사 게이트웨이 (gw_recent_web / Gateway List 기준)
 * 맵 좌·나열 순서: 서버실 → 2회의실 → 중앙 실험실
 */
export const SNU_GATEWAYS = [
  {
    gateway_mac: '1051DB363D62',
    location: '3층 서버실',
    displayName: '3층 서버실'
  },
  {
    gateway_mac: '1051DB26FA7E',
    location: '3층 2회의실',
    displayName: '3층 2회의실'
  },
  {
    gateway_mac: 'F0F5BD55FA86',
    location: '3층 중앙 실험실',
    displayName: '3층 중앙 실험실'
  }
];
